
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { NextSeo } from 'next-seo';
import useTranslation from 'next-translate/useTranslation';
import Image from 'next/image';
import Link from 'next/link';
import { GetStaticProps, NextPage } from 'next/types';
import { PAGE } from '../consts/PAGES';
import { getPageById } from '../utils/getPage';
interface IPage {
    page: {
        title: string;
        content: string;
        aboutPage: {
            awardsTitle: string;
            awardsContent: string;
            innovationContent: string;
            innovationTitle: string;
            technologyContent: string;
            technologyTitle: string;
            title: string;
            awardsImages: {
                image: {
                    sourceUrl: string;
                };
                year: string;
                title: string;
            }[];
        };
        en: {
            title: string;
            content: string;
            aboutPage: {
                awardsTitle: string;
                awardsContent: string;
                innovationContent: string;
                innovationTitle: string;
                technologyContent: string;
                technologyTitle: string;
                title: string;
                awardsImages: [
                    image: {
                        sourceUrl: string;
                    }
                ];
            };
        };
    };
}
const About: NextPage<IPage> = ({ page }) => {
    const { t, lang } = useTranslation('common');
    const Video = {
        pl: 'https://www.youtube.com/embed/R0HGcK_3-fs',
        en: 'https://www.youtube.com/embed/AYAROw6HSQ8',
        de: 'https://www.youtube.com/embed/EiiqNIwmnRE',
        it: 'https://www.youtube.com/embed/SAbMrLVyF7U',
        fr: 'https://www.youtube.com/embed/AYAROw6HSQ8',
        cs: 'https://www.youtube.com/embed/AYAROw6HSQ8',
        hu: 'https://www.youtube.com/embed/AYAROw6HSQ8',
    };
    return (<>
      <NextSeo languageAlternates={[
            { hrefLang: 'x-default', href: 'https://knsokna.pl/about-us' },
            { hrefLang: 'en', href: 'https://knswindows.com/about-us' },
            { hrefLang: 'pl', href: 'https://knsokna.pl/about-us' },
            { hrefLang: 'de', href: 'https://knsfenster.de/about-us' },
            { hrefLang: 'cs', href: 'https://kns-okna.eu/about-us' },
            { hrefLang: 'it', href: 'https://knsfinestre.it/about-us' },
            { hrefLang: 'fr', href: 'https://knsfenetres.fr/about-us' },
            { hrefLang: 'hu', href: 'https://knsokna.eu/about-us' },
        ]}/>
      <div className="bg-white">
        <div className="w-full bg-black text-white">
          <Image src="/img/kns-production.jpg" alt="about" width="1676" height="601" className="w-full"/>
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:py-6 lg:px-8 text-center">
            <h1 className="bg-gradient-to-r from-red to-orange text-white text-xl font-bold inline-block px-4 py-1 my-3">
              {page?.aboutPage?.title
            ? page.aboutPage?.title
            : page?.en?.aboutPage?.title}
            </h1>
            <div className="py-3" dangerouslySetInnerHTML={{
            __html: page?.content ? page?.content : page?.en?.content,
        }}/>
          </div>
        </div>

        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 text-center">
          ...
        </div>

        <div className="w-full bg-black text-white">
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:py-6 lg:px-8 text-center">
            <h1 className="bg-gradient-to-r from-red to-orange text-white text-xl font-bold inline-block px-4 py-1 my-3">
              {page.aboutPage?.innovationTitle
            ? page.aboutPage?.innovationTitle
            : page?.en?.aboutPage?.innovationTitle}
            </h1>
            <div className="py-3" dangerouslySetInnerHTML={{
            __html: page?.aboutPage?.innovationContent
                ? page.aboutPage?.innovationContent
                : page?.en?.aboutPage?.innovationContent,
        }}/>
          </div>
          <div className="relative h-0 overflow-hidden max-w-7xl mx-auto" style={{ paddingBottom: '56.25%' }}>
            <iframe className="absolute top-0 left-0 w-full h-full" src={Video[lang]} title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
          </div>
        </div>

        <div className="w-full pb-6">
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:py-6 lg:px-8 text-center">
            <h1 className="bg-gradient-to-r from-red to-orange text-white text-xl font-bold inline-block px-4 py-1 my-3">
              {page.aboutPage?.technologyTitle
            ? page.aboutPage?.technologyTitle
            : page?.en?.aboutPage?.technologyTitle}
            </h1>
            <div className="py-3" dangerouslySetInnerHTML={{
            __html: page?.aboutPage?.technologyContent
                ? page.aboutPage?.technologyContent
                : page?.en?.aboutPage?.technologyContent,
        }}/>
          </div>
          <div className="flex justify-center text-center">
            <div className="max-w-[160px]">
              <Link href="/certificates" className="uppercase">
                <Image src="/img/about/certificates.png" width="362" height="363" alt="certifications"/>
                {t('certificates')}
              </Link>
            </div>
            <div className="max-w-[160px]">
              <Link href="/pvc/v-perfect">
                <Image src="/img/about/v_perfect.png" width="363" height="363" alt="v-perfect"/>
                V-PERFECT
              </Link>
            </div>
          </div>
        </div>

        <div className="w-full bg-black text-white">
          <Image src="/img/quality.jpg" alt="about" width="1724" height="612"/>
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:py-6 lg:px-8 text-center">
            <h1 className="bg-gradient-to-r from-red to-orange text-white text-xl font-bold inline-block px-4 py-1 my-3">
              {page.aboutPage?.awardsTitle
            ? page.aboutPage?.awardsTitle
            : page?.en?.aboutPage?.awardsTitle}
            </h1>
            <div className="py-3" dangerouslySetInnerHTML={{
            __html: page?.aboutPage?.awardsContent
                ? page.aboutPage?.awardsContent
                : page?.en?.aboutPage?.awardsContent,
        }}/>
          </div>
        </div>
        <div className="bg-white">
          <div className="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:py-6 lg:px-8 text-center">
            <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-4 text-left">
              {page?.aboutPage?.awardsImages?.map((award) => {
            return (<div className="flex flex-col">
                    <Link href={award.image.sourceUrl} target="_blank">
                      <Image src={award.image.sourceUrl} alt="about" width="130" height="60"/>
                    </Link>
                    Rok: {award.year}
                    <br />
                    {award.title}
                  </div>);
        })}
            </div>
          </div>
        </div>
      </div>
    </>);
};
const getStaticProps: GetStaticProps = async (context) => {
    const locale = context.locale || 'PL';
    const LOCALE = locale === 'cz' ? 'CS' : locale.toUpperCase();
    const PAGE_ID = PAGE.ABOUTUS[LOCALE as keyof typeof PAGE.ABOUTUS] || 1;
    const { page } = await getPageById(PAGE_ID);
    return {
        props: {
            page,
        },
    };
};
export default About;

    async function __Next_Translate__getStaticProps__196386c4eea__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/about-us',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__196386c4eea__ as getStaticProps }
  